__turbopack_context__.v({
  "arrow": "news-module-scss-module__MVWr6q__arrow",
  "card": "news-module-scss-module__MVWr6q__card",
  "cardBody": "news-module-scss-module__MVWr6q__cardBody",
  "container": "news-module-scss-module__MVWr6q__container",
  "date": "news-module-scss-module__MVWr6q__date",
  "excerpt": "news-module-scss-module__MVWr6q__excerpt",
  "eyebrow": "news-module-scss-module__MVWr6q__eyebrow",
  "grid": "news-module-scss-module__MVWr6q__grid",
  "head": "news-module-scss-module__MVWr6q__head",
  "heading": "news-module-scss-module__MVWr6q__heading",
  "news": "news-module-scss-module__MVWr6q__news",
  "readMore": "news-module-scss-module__MVWr6q__readMore",
  "title": "news-module-scss-module__MVWr6q__title",
});
